import { Record as record } from 'immutable';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

export var Company = record({
  tvnId: null,
  name: null,
  manualTrialCreation: null,
  helpdeskContactInfo: null,
  passwordStrength: null,
  systemInformationHeading: null,
  systemInformationMessage: null,
  helpURL: null,
  groupLoggers: null
});

Company.normalize = function (data) {
  var normalized = Object.assign({}, data);

  return normalized;
};

export var CompanyShape = ImmutablePropTypes.recordOf({
  tvnId: PropTypes.string,
  name: PropTypes.string,
  manualTrialCreation: PropTypes.boolean,
  helpdeskContactInfo: PropTypes.string,
  passwordStrength: PropTypes.number,
  systemInformationHeading: PropTypes.string,
  systemInformationMessage: PropTypes.string,
  helpURL: PropTypes.string,
  groupLoggers: PropTypes.boolean
});

export var CompanyShapeList = ImmutablePropTypes.listOf(CompanyShape);